<mat-list *transloco="let t">
  <mat-list-item (click)="update()">
    <mat-icon mat-list-icon *ngIf="!updateAvailable"></mat-icon>
    <mat-icon mat-list-icon *ngIf="updateAvailable">system_update</mat-icon>
    <h4 mat-line>{{ version }}</h4>
    <p mat-line *ngIf="updateAvailable">{{ t.update_available }}</p>
  </mat-list-item>
</mat-list>
